module.exports = __webpack_public_path__ + "media/metronic/_theme/media/demos/preview/demo21-9374a8ad8f1869f1097d1642a49c7800.jpg";